import React from 'react';
import { styled, useStyletron } from 'baseui';
import { ParagraphSmall } from 'baseui/typography';
import { formatFrameRange } from '../../../modernization-common/relationships/utils';
import type { RelationshipAttributeT } from '../types';
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: $theme.sizing.scale100,
  padding: `${$theme.sizing.scale100} 0`
}));
export const RelationshipAttributeItem = ({
  relationshipLabelName,
  targetAnnotationName,
  targetAnnotationColor,
  frameRanges
}: RelationshipAttributeT) => {
  const [, theme] = useStyletron();
  const frameRangeText = frameRanges.map(formatFrameRange).join(', ');
  return <Container>
      <ParagraphSmall color={theme.colors.contentTertiary} margin={0}>
        {relationshipLabelName}
      </ParagraphSmall>
      <ParagraphSmall color={targetAnnotationColor ?? theme.colors.contentAccent} margin={0}>
        {targetAnnotationName}
      </ParagraphSmall>
      {frameRangeText && <ParagraphSmall color={theme.colors.contentPrimary} margin={0}>
          {`: ${frameRangeText}`}
        </ParagraphSmall>}
    </Container>;
};